export default "__VITE_ASSET__43hBaDFe__"